module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nescafe-2-4dd1f8870d38137f33be1bedae309834.jpg";